export default __webpack_public_path__ + "static/media/group_7724-112.6ed8f560.png";